<template>
    <section>
        <div class="join_section2" style="display: flex; align-items: center; position: relative;">
            <div class="con_wrap" style="display: flex; align-items: flex-start; flex-direction: column;">
                <p style="font-size: 35px; font-weight: 700; color: black; margin-bottom: 76px;">채용절차</p> 
                <div style="display: flex; font-weight: 400; color: #5A5A5A; margin-bottom: 70px;">
                    <div v-for="(item, index) in joinProcess" :key="index" 
                        data-aos="fade"
                        :data-aos-delay="100 * index"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" class="box_join_process" :style="{width: item.size + 'px', backgroundColor: item.color}">
                        {{item.text}}
                    </div>
                </div>
                <div data-aos="fade-up"
                        :data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="margin-bottom: 246px;">
                    <p style="font-size: 25px; line-height: 1.5; font-weight: 700; color: black;">채용은 서류전형과 대면면접으로 이루어집니다.</p>
                    <p style="font-size: 21px; line-height: 1.5; font-weight: 500;">
                        위 내용은 영입을 위한 기본 프로세스로 경우에 따라 추가 절차가 포함될 수 있습니다.<br>
                        최종 합격 시, 합격자에 한해 개별적으로 합격통보 연락을 드립니다.
                    </p>
                </div>
                <div  style="display: flex; height: 562px">
                    <img data-aos="fade"
                        data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="500"
                        data-aos-easing="ease-in-out" src="@/assets/images/main_v2/background_section5-2.svg" alt="" style="margin-right: 30px;">
                    <img data-aos="fade"
                        data-aos-delay="100"
                        data-aos-once="true"
                        data-aos-duration="500"
                        data-aos-easing="ease-in-out" src="@/assets/images/main_v2/background_section5-3.svg" alt="">
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon,
    },
    data() {
        return {
            joinProcess: [
                {
                    'text': '서류전형',
                    'size': 483,
                    'color' : '#1C9CD3'
                },{
                    'text': '대면면접',
                    'size': 278,
                    'color' : '#1C9CD399'
                },{
                    'text': '결과',
                    'size': 123,
                    'color' : '#1C9CD333'
                },
            ],
            // webUrl: "https://www.pulda.net",
            // appleUrl: "https://apps.apple.com/app/id1530892838",
            // googleUrl:
            //     "https://play.google.com/store/apps/details?id=com.filledu.pulda2",
            // adminEmail: 'admin@filledyou.com',
            // showSnackBar: false,
            // snackbarInfo: {
            //     text: '',
            //     icon: '',
            //     color: '',
            //     background: ''
            // },
        }
    },
    methods: {
        openLink(val) {
            window.open(val, '_blank')
        },
        // copy(val) {
        //     navigator.clipboard.writeText(val).then(()=> {
        //         this.$store.commit('SET_SNACK_BAR_INFO' , {
        //             text: '메일주소가 복사되었습니다.',
        //             icon: 'icon-check.svg',
        //             color: 'white',
        //             background: '#1C9CD3'
        //         })
        //         this.showSnackBar = true
        //     })
        // },
    }
    
}
</script>
<style>
    .join_section2 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
    .box_join_process {
        padding: 38px 0; 
        border-radius: 100px;
        margin-right: 30px;
        font-weight: 700;
        font-size: 28px;
        color: black; 
        line-height: 1.5; 
        text-align: center;
    }
</style>